export {};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') console.log = function () {};
